var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(option,index){return _c('CRButton',{key:`${option.value}-${index}`,on:{"click":function($event){return _vm.handleClick(option.value)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }